import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import StatsSection from './components/StatsSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '男同网',
    url: 'https://nantong.wang',
    description: '男同网是专为男同群体打造的综合性平台，提供交友认识、社群互动、生活资讯、健康指南及活动资讯。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://nantong.wang/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '男同网',
    url: 'https://nantong.wang',
    description: '专为男同群体打造的综合性平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@nantong.wang',
      contactType: 'customer service',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '男同网是免费的吗？如何使用交友功能？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，男同网的所有基础功能完全免费。你可以浏览文章、参与社群讨论、查看活动资讯。交友功能通过社群互动和活动参与自然展开。',
        },
      },
      {
        '@type': 'Question',
        name: '平台如何保护我的隐私和安全？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '你的隐私安全是我们的首要考量。所有个人信息均采用加密存储，你可以自主选择公开或隐藏个人资料。',
        },
      },
      {
        '@type': 'Question',
        name: '男同网的文章内容可靠吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的内容团队由专业人士和社群达人组成。健康指南类内容经过医疗专业人士审核。',
        },
      },
      {
        '@type': 'Question',
        name: '如何参与线下活动？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '在活动资讯频道可以查看全国各地的最新活动。每场活动都有详细的报名方式和参与须知。',
        },
      },
      {
        '@type': 'Question',
        name: '我可以投稿吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '非常欢迎！你可以通过关于我们页面的联系表单提交稿件，或者发送至官方邮箱。编辑团队会在3个工作日内审核并回复。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <StatsSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}